var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-btn",
        {
          staticClass: "btn action-btn",
          attrs: {
            disabled:
              _vm.selectedLabel.length === 0 || _vm.scheduleSettingsButton,
            text: "",
            "v-model": _vm.LabelSchedulepopup
          },
          on: {
            click: function($event) {
              return _vm.openScheduleModel($event)
            }
          }
        },
        [_vm._v(_vm._s(_vm.$t("Schedule Settings")))]
      ),
      _c(
        "div",
        [
          _c(
            "v-dialog",
            {
              attrs: { scrollable: "", persistent: "", width: "1300" },
              model: {
                value: _vm.LabelSchedulepopup,
                callback: function($$v) {
                  _vm.LabelSchedulepopup = $$v
                },
                expression: "LabelSchedulepopup"
              }
            },
            [
              _c(
                "v-card",
                { staticClass: "popup add_store_popup" },
                [
                  _c("v-card-title", [
                    _c("h3", { staticClass: "page-title-bar" }, [
                      _c("i", { staticClass: "ico ico-label" }),
                      _vm._v(_vm._s(_vm.$t("Schedule Setting")) + " ")
                    ])
                  ]),
                  _c(
                    "v-card-text",
                    [
                      _c(
                        "v-tabs",
                        {
                          staticClass: "tabBgColor",
                          attrs: { grow: "" },
                          model: {
                            value: _vm.tabData,
                            callback: function($$v) {
                              _vm.tabData = $$v
                            },
                            expression: "tabData"
                          }
                        },
                        [
                          _c(
                            "v-tab",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.ChangeTab("Schedule")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Schedule")))]
                          ),
                          _c(
                            "v-tab",
                            {
                              on: {
                                click: function($event) {
                                  return _vm.ChangeTab("RepeatSchedule")
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Repeat Schedule")))]
                          ),
                          _c("v-tab-item", { staticClass: "tabitemclass" }, [
                            _c(
                              "div",
                              { staticStyle: { padding: "25px" } },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "10" } },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-menu",
                                                  {
                                                    attrs: {
                                                      "close-on-content-click": false,
                                                      transition:
                                                        "scale-transition",
                                                      "offset-y": "",
                                                      width: "50px"
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          var attrs = ref.attrs
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    ref:
                                                                      "calendarstart",
                                                                    staticClass:
                                                                      "form-select mb-4 col mandatory",
                                                                    staticStyle: {
                                                                      "max-width":
                                                                        "170px",
                                                                      float:
                                                                        "left"
                                                                    },
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "Start Time"
                                                                        ) + "*",
                                                                      placeholder:
                                                                        "" +
                                                                        _vm.$t(
                                                                          "Select Start Date"
                                                                        ),
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      readonly:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      "prepend-icon":
                                                                        "",
                                                                      "append-icon":
                                                                        "mdi-calendar-month"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.setCurrentStartDate,
                                                                      "click:append": function(
                                                                        $event
                                                                      ) {
                                                                        _vm.$refs.calendarstart.$el
                                                                          .querySelector(
                                                                            "input"
                                                                          )
                                                                          .click()
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.scheduleStartTime,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.scheduleStartTime = $$v
                                                                      },
                                                                      expression:
                                                                        "scheduleStartTime"
                                                                    }
                                                                  },
                                                                  "v-text-field",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              )
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ]),
                                                    model: {
                                                      value:
                                                        _vm.schedule
                                                          .showStartDatePicker,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.schedule,
                                                          "showStartDatePicker",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "schedule.showStartDatePicker"
                                                    }
                                                  },
                                                  [
                                                    _c("date-picker", {
                                                      attrs: {
                                                        mode: "date",
                                                        "min-date": new Date(),
                                                        "minute-increment": 1,
                                                        "is-required": true,
                                                        is24hr: "",
                                                        "model-config": {
                                                          type: "string",
                                                          mask: "YYYY-MM-DD"
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.scheduleStartTime,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.scheduleStartTime = $$v
                                                        },
                                                        expression:
                                                          "scheduleStartTime"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    items: _vm.getHours,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.startTimeHoursSelection,
                                                    callback: function($$v) {
                                                      _vm.startTimeHoursSelection = $$v
                                                    },
                                                    expression:
                                                      "startTimeHoursSelection"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "mt-8 pl-3" },
                                                  [_vm._v(":")]
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    "v-label":
                                                      _vm.$t("End Time") + "*",
                                                    items: _vm.getMinutes,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.startTimeMinutesSelection,
                                                    callback: function($$v) {
                                                      _vm.startTimeMinutesSelection = $$v
                                                    },
                                                    expression:
                                                      "startTimeMinutesSelection"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mt-8 pl-3 pr-3"
                                                  },
                                                  [_vm._v(" ~ ")]
                                                ),
                                                _c(
                                                  "v-menu",
                                                  {
                                                    staticClass: "ml-3",
                                                    attrs: {
                                                      "close-on-content-click": false,
                                                      transition:
                                                        "scale-transition",
                                                      "offset-y": "",
                                                      width: "50px"
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          var attrs = ref.attrs
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    ref:
                                                                      "calendarend",
                                                                    staticClass:
                                                                      "form-select mb-4 col mandatory",
                                                                    staticStyle: {
                                                                      "max-width":
                                                                        "160px"
                                                                    },
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "End Time"
                                                                        ) + "*",
                                                                      placeholder:
                                                                        "" +
                                                                        _vm.$t(
                                                                          "Select End Date"
                                                                        ),
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      readonly:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      "prepend-icon":
                                                                        "",
                                                                      "append-icon":
                                                                        "mdi-calendar-month"
                                                                    },
                                                                    on: {
                                                                      "click:clear": function(
                                                                        $event
                                                                      ) {
                                                                        _vm.scheduleEndTime = null
                                                                      },
                                                                      click:
                                                                        _vm.setCurrentEndDate,
                                                                      "click:append": function(
                                                                        $event
                                                                      ) {
                                                                        _vm.$refs.calendarend.$el
                                                                          .querySelector(
                                                                            "input"
                                                                          )
                                                                          .click()
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.scheduleEndTime,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.scheduleEndTime = $$v
                                                                      },
                                                                      expression:
                                                                        "scheduleEndTime"
                                                                    }
                                                                  },
                                                                  "v-text-field",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              )
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ]),
                                                    model: {
                                                      value:
                                                        _vm.schedule
                                                          .showEndDatePicker,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.schedule,
                                                          "showEndDatePicker",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "schedule.showEndDatePicker"
                                                    }
                                                  },
                                                  [
                                                    _c("date-picker", {
                                                      attrs: {
                                                        mode: "date",
                                                        "min-date":
                                                          _vm.scheduleStartTime,
                                                        "minute-increment": 1,
                                                        "is-required": true,
                                                        is24hr: "",
                                                        "model-config": {
                                                          type: "string",
                                                          mask: "YYYY-MM-DD"
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.scheduleEndTime,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.scheduleEndTime = $$v
                                                        },
                                                        expression:
                                                          "scheduleEndTime"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    "v-label":
                                                      _vm.$t("End Time") + "*",
                                                    items: _vm.getHours,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.endTimeHoursSelection,
                                                    callback: function($$v) {
                                                      _vm.endTimeHoursSelection = $$v
                                                    },
                                                    expression:
                                                      "endTimeHoursSelection"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "mt-8 pl-3" },
                                                  [_vm._v(":")]
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    "v-label":
                                                      _vm.$t("End Time") + "*",
                                                    items: _vm.getMinutes,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.endTimeMinutesSelection,
                                                    callback: function($$v) {
                                                      _vm.endTimeMinutesSelection = $$v
                                                    },
                                                    expression:
                                                      "endTimeMinutesSelection"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "d-flex" },
                                              [
                                                _c("v-select", {
                                                  staticStyle: {
                                                    "max-width": "160px"
                                                  },
                                                  attrs: {
                                                    label:
                                                      "" +
                                                      _vm.$t("Display Page"),
                                                    items: _vm.PageListarray,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.displayPageSchedule,
                                                    callback: function($$v) {
                                                      _vm.displayPageSchedule = $$v
                                                    },
                                                    expression:
                                                      "displayPageSchedule"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn mt-6 ml-3",
                                            staticStyle: {
                                              height: "120px",
                                              width: "130px"
                                            },
                                            on: { click: _vm.AddSceduleddate }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "line-height": "119px"
                                                }
                                              },
                                              [_vm._v("Add")]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c("v-col", { attrs: { cols: "12" } }, [
                                      _c("div", { staticClass: "mt-8" }, [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-data-table",
                                              {
                                                staticClass: "tbl-type01",
                                                attrs: {
                                                  headers: _vm.scheduleHeaders,
                                                  items: _vm.scheduleList,
                                                  "item-key": "id",
                                                  "hide-default-footer": true,
                                                  "fixed-header": "",
                                                  height: "240",
                                                  "disable-pagination": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "item.sno",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c("td", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.scheduleList.indexOf(
                                                                    item
                                                                  ) + 1
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "item.icon",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticStyle: {
                                                                color: "red"
                                                              },
                                                              attrs: {
                                                                medium: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.deleteSelectedSchedule(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close-circle "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "no-data" },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "No data available"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ]),
                          _c("v-tab-item", { staticClass: "tabitemclass" }, [
                            _c(
                              "div",
                              { staticStyle: { padding: "25px" } },
                              [
                                _c(
                                  "v-row",
                                  [
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "10" } },
                                      [
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              { staticClass: "d-flex" },
                                              [
                                                _c(
                                                  "v-menu",
                                                  {
                                                    attrs: {
                                                      "close-on-content-click": false,
                                                      transition:
                                                        "scale-transition",
                                                      "offset-y": "",
                                                      width: "50px"
                                                    },
                                                    scopedSlots: _vm._u([
                                                      {
                                                        key: "activator",
                                                        fn: function(ref) {
                                                          var on = ref.on
                                                          var attrs = ref.attrs
                                                          return [
                                                            _c(
                                                              "v-text-field",
                                                              _vm._g(
                                                                _vm._b(
                                                                  {
                                                                    ref:
                                                                      "Repeatcalendarstart",
                                                                    staticClass:
                                                                      "form-select mb-4 col mandatory",
                                                                    staticStyle: {
                                                                      "max-width":
                                                                        "170px",
                                                                      float:
                                                                        "left"
                                                                    },
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "Start Date"
                                                                        ) + "*",
                                                                      placeholder:
                                                                        "" +
                                                                        _vm.$t(
                                                                          "Select Start Date"
                                                                        ),
                                                                      outlined:
                                                                        "",
                                                                      dense: "",
                                                                      "hide-details":
                                                                        "",
                                                                      readonly:
                                                                        "",
                                                                      clearable:
                                                                        "",
                                                                      "prepend-icon":
                                                                        "",
                                                                      "append-icon":
                                                                        "mdi-calendar-month"
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.repeatscheduleStartTimeset,
                                                                      "click:append": function(
                                                                        $event
                                                                      ) {
                                                                        _vm.$refs.Repeatcalendarstart.$el
                                                                          .querySelector(
                                                                            "input"
                                                                          )
                                                                          .click()
                                                                      }
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        _vm.repeatscheduleStartTime,
                                                                      callback: function(
                                                                        $$v
                                                                      ) {
                                                                        _vm.repeatscheduleStartTime = $$v
                                                                      },
                                                                      expression:
                                                                        "repeatscheduleStartTime"
                                                                    }
                                                                  },
                                                                  "v-text-field",
                                                                  attrs,
                                                                  false
                                                                ),
                                                                on
                                                              )
                                                            )
                                                          ]
                                                        }
                                                      }
                                                    ])
                                                  },
                                                  [
                                                    _c("date-picker", {
                                                      attrs: {
                                                        mode: "date",
                                                        "min-date": new Date(),
                                                        "minute-increment": 1,
                                                        "is-required": true,
                                                        is24hr: "",
                                                        "model-config": {
                                                          type: "string",
                                                          mask: "YYYY-MM-DD"
                                                        }
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.repeatscheduleStartTime,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.repeatscheduleStartTime = $$v
                                                        },
                                                        expression:
                                                          "repeatscheduleStartTime"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      position: "absolute",
                                                      top: "38px",
                                                      left: "223px",
                                                      "font-size": "12px"
                                                    }
                                                  },
                                                  [_vm._v(" Time ")]
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    items: _vm.getHours,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.repeatstartTimeHoursSelection,
                                                    callback: function($$v) {
                                                      _vm.repeatstartTimeHoursSelection = $$v
                                                    },
                                                    expression:
                                                      "repeatstartTimeHoursSelection"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "mt-8 pl-3" },
                                                  [_vm._v(":")]
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    items: _vm.getMinutes,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.repeatstartTimeMinutesSelection,
                                                    callback: function($$v) {
                                                      _vm.repeatstartTimeMinutesSelection = $$v
                                                    },
                                                    expression:
                                                      "repeatstartTimeMinutesSelection"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "mt-8 pl-3 pr-3 ml-2"
                                                  },
                                                  [_vm._v(" ~ ")]
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    "v-label":
                                                      _vm.$t("End Time") + "*",
                                                    items: _vm.getHours,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.repeatendTimeHoursSelection,
                                                    callback: function($$v) {
                                                      _vm.repeatendTimeHoursSelection = $$v
                                                    },
                                                    expression:
                                                      "repeatendTimeHoursSelection"
                                                  }
                                                }),
                                                _c(
                                                  "span",
                                                  { staticClass: "mt-8 pl-3" },
                                                  [_vm._v(":")]
                                                ),
                                                _c("v-select", {
                                                  staticClass: "mt-6 pl-3",
                                                  staticStyle: {
                                                    "max-width": "85px"
                                                  },
                                                  attrs: {
                                                    "v-label":
                                                      _vm.$t("End Time") + "*",
                                                    items: _vm.getMinutes,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.repeatendTimeMinutesSelection,
                                                    callback: function($$v) {
                                                      _vm.repeatendTimeMinutesSelection = $$v
                                                    },
                                                    expression:
                                                      "repeatendTimeMinutesSelection"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-row",
                                          [
                                            _c(
                                              "v-col",
                                              {
                                                staticStyle: {
                                                  "margin-left": "9px"
                                                },
                                                attrs: { cols: "7" }
                                              },
                                              [
                                                _c(
                                                  "small",
                                                  {
                                                    staticClass: "repeatdaysCss"
                                                  },
                                                  [_vm._v("Repeat Days")]
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "row" },
                                                  _vm._l(
                                                    _vm.getWeekDaysSelected,
                                                    function(item, i) {
                                                      return _c(
                                                        "div",
                                                        {
                                                          key: i,
                                                          staticClass:
                                                            "cart-size",
                                                          class: item.selected
                                                            ? "active-day"
                                                            : "not-active-day",
                                                          on: {
                                                            click: function(
                                                              $event
                                                            ) {
                                                              return _vm.selectAssignFunction(
                                                                item,
                                                                i
                                                              )
                                                            }
                                                          }
                                                        },
                                                        [
                                                          _c("small", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  item.name
                                                                )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            ),
                                            _c(
                                              "v-col",
                                              {
                                                staticClass: "d-flex",
                                                attrs: { cols: "4" }
                                              },
                                              [
                                                _c("v-select", {
                                                  staticStyle: {
                                                    "max-width": "160px"
                                                  },
                                                  attrs: {
                                                    label:
                                                      "" +
                                                      _vm.$t("Display Page"),
                                                    items: _vm.PageListarray,
                                                    outlined: "",
                                                    dense: "",
                                                    "hide-details": ""
                                                  },
                                                  scopedSlots: _vm._u([
                                                    {
                                                      key: "item",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticStyle: {
                                                                "font-size":
                                                                  "0.8125rem"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "selection",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "LedPatternClass",
                                                              staticStyle: {
                                                                display:
                                                                  "contents !important"
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.$t(item)
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ]),
                                                  model: {
                                                    value:
                                                      _vm.repeatdisplayPageSchedule,
                                                    callback: function($$v) {
                                                      _vm.repeatdisplayPageSchedule = $$v
                                                    },
                                                    expression:
                                                      "repeatdisplayPageSchedule"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-col",
                                      { attrs: { cols: "2" } },
                                      [
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass: "btn mt-6 ml-3",
                                            staticStyle: {
                                              height: "120px",
                                              width: "148px"
                                            },
                                            on: {
                                              click: _vm.AddRepeatSceduleddate
                                            }
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  "line-height": "119px"
                                                }
                                              },
                                              [_vm._v("Add")]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "v-row",
                                  [
                                    _c("v-col", { attrs: { cols: "12" } }, [
                                      _c("div", { staticClass: "mt-8" }, [
                                        _c(
                                          "div",
                                          [
                                            _c(
                                              "v-data-table",
                                              {
                                                staticClass: "tbl-type01",
                                                attrs: {
                                                  headers:
                                                    _vm.repeatscheduleHeaders,
                                                  items: _vm.repeatscheduleList,
                                                  "item-key": "id",
                                                  "hide-default-footer": true,
                                                  "fixed-header": "",
                                                  height: "240",
                                                  "disable-pagination": ""
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "item.sno",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c("td", [
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  _vm.repeatscheduleList.indexOf(
                                                                    item
                                                                  ) + 1
                                                                ) +
                                                                " "
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    },
                                                    {
                                                      key: "item.icon",
                                                      fn: function(ref) {
                                                        var item = ref.item
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              staticStyle: {
                                                                color: "red"
                                                              },
                                                              attrs: {
                                                                medium: ""
                                                              },
                                                              on: {
                                                                click: function(
                                                                  $event
                                                                ) {
                                                                  return _vm.deleteSelectedRepeatSchedule(
                                                                    item
                                                                  )
                                                                }
                                                              }
                                                            },
                                                            [
                                                              _vm._v(
                                                                "mdi-close-circle "
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  true
                                                )
                                              },
                                              [
                                                _c(
                                                  "template",
                                                  { slot: "no-data" },
                                                  [
                                                    _c("p", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "No data available"
                                                          )
                                                        )
                                                      )
                                                    ])
                                                  ]
                                                )
                                              ],
                                              2
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm.tabData === 0
                    ? _c(
                        "v-card-actions",
                        { staticClass: "d-flex justify-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.topostSchedullist()
                                  _vm.LabelSchedulepopup = false
                                }
                              }
                            },
                            [_vm._v(" " + _vm._s(_vm.$t("Save")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.LabelSchedulepopup = false
                                  _vm.resetLabel()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Cancel")))]
                          )
                        ],
                        1
                      )
                    : _c(
                        "v-card-actions",
                        { staticClass: "d-flex justify-center" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.topostRepeatSchedullist()
                                  _vm.LabelSchedulepopup = false
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Save")))]
                          ),
                          _c(
                            "v-btn",
                            {
                              staticClass: "btn",
                              attrs: { text: "", icon: "" },
                              on: {
                                click: function($event) {
                                  _vm.LabelSchedulepopup = false
                                  _vm.resetLabel()
                                }
                              }
                            },
                            [_vm._v(_vm._s(_vm.$t("Cancel")))]
                          )
                        ],
                        1
                      )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }